import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _everyInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/every';
import { getPlainOptionsFromGroups, getOptionValue } from '../select/selectors.js';

var getGroups = function getGroups(state) {
  var groups = state.searchString && state.searchString !== '' ? state.filteredGroups : state.groups;
  return state.hideSelected ? state.groupsWithoutSelected : groups;
};
var isEmpty = function isEmpty(state) {
  var groups = getGroups(state);
  return groups.length === 0 || _everyInstanceProperty(groups).call(groups, function (g) {
    return g.options.length === 0;
  });
};
var getPlainOptions = function getPlainOptions(state) {
  return getPlainOptionsFromGroups(getGroups(state));
};
var isSelected = function isSelected(state, value) {
  var _context;

  if (!state.selected) {
    return false;
  }

  return Boolean(_findInstanceProperty(_context = state.selected).call(_context, function (o) {
    return getOptionValue(o) === value;
  }));
};
var getSelectedArray = function getSelectedArray(state) {
  return state.selected ? state.selected : [];
};

export { getGroups, getPlainOptions, getSelectedArray, isEmpty, isSelected };
